import React from 'react';

interface NoGameMessageProps {
  loading: boolean;
  onStartGame: () => void;
}

export const NoGameMessage: React.FC<NoGameMessageProps> = ({ loading, onStartGame }) => {
  return (
    <div className="no-game">
      <p>{loading ? 'The game is loading...' : 'No game found.'}</p>
    </div>
  );
};
